import { render, staticRenderFns } from "./Host.vue?vue&type=template&id=128bfa9d&scoped=true"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"
import style0 from "./Host.vue?vue&type=style&index=0&id=128bfa9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bfa9d",
  null
  
)

export default component.exports